<script lang="ts">
	import SparklesIcon from '@lucide/svelte/icons/sparkles';

	let { onNext }: { onNext: () => void } = $props();
</script>

<!-- v09 welcome: a glass medallion, one honest line, a single CTA. No bullet
     list, no "isolated sandbox" claim. The whole step is centered in the
     wizard's glass container; chrome comes from the parent. -->
<div class="flex flex-col items-center gap-8 pt-2 text-center">
	<!-- Glass tile + soft glow ring -->
	<div class="relative">
		<div
			class="grid size-14 place-items-center rounded-[14px] border bg-[var(--glass)] backdrop-blur-md"
			style="border-color: var(--glass-border-strong);"
		>
			<SparklesIcon class="size-5 text-primary" />
		</div>
		<div
			class="pointer-events-none absolute -inset-px rounded-[14px]"
			style="box-shadow: 0 0 30px var(--glow-soft);"
			aria-hidden="true"
		></div>
	</div>

	<div class="flex flex-col gap-3">
		<h2
			class="text-[28px] font-medium tracking-[-0.025em] text-[color:var(--fg-strong)] sm:text-[32px]"
		>
			Welcome.
		</h2>
		<p
			class="max-w-sm text-[13.5px] leading-relaxed text-[color:var(--muted-foreground)]"
		>
			Your workspace is private to you; each chat keeps its own files.
		</p>
	</div>

	<button
		type="button"
		onclick={onNext}
		class="mt-2 inline-flex items-center justify-center rounded-full bg-primary px-7 py-2.5 text-[13px] font-medium text-primary-foreground transition-colors hover:bg-[color:var(--primary)]/90"
		style="box-shadow: 0 8px 28px -10px var(--glow), 0 0 0 1px rgba(255,255,255,0.06) inset;"
	>
		Begin
	</button>
</div>
